import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgBiLogInCircle = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <path
      d="M7.332 10.667 10.665 8 7.332 5.333v2h-6v1.334h6v2Z"
      fill="#8181A5"
    />
    <path
      d="M8.666 2a5.959 5.959 0 0 0-4.243 1.758l.943.942a4.637 4.637 0 0 1 3.3-1.367c1.247 0 2.419.486 3.3 1.367A4.637 4.637 0 0 1 13.333 8a4.637 4.637 0 0 1-1.367 3.3 4.637 4.637 0 0 1-3.3 1.367 4.637 4.637 0 0 1-3.3-1.367l-.943.943A5.959 5.959 0 0 0 8.666 14a5.96 5.96 0 0 0 4.243-1.758A5.96 5.96 0 0 0 14.667 8c0-1.603-.625-3.11-1.758-4.242A5.96 5.96 0 0 0 8.666 2Z"
      fill="#8181A5"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgBiLogInCircle);
export default ForwardRef;
